<script lang="ts">
	import { page } from '$app/state';
	import HDTeamDetails from '#lib/hockeydata/components/HDTeamDetails.svelte';
	import { twMerge } from 'tailwind-merge';

	const { data, params, children } = $props();
</script>

<svelte:head>
	<title>
		Tigers Paternion | Team {data.team.data.teamData.teamShortname}
	</title>
</svelte:head>

<div class="flex flex-col gap-3">
	<h3 id="teamContent" class="border-accent border-b font-bold uppercase">
		{data.team.data.teamData.teamLongname}
	</h3>

	<HDTeamDetails team={data.team.data} teamImage={data.teamImage} standings={data.standings.data} />

	{#snippet menuItem(route: string, label: string, exact?: boolean)}
		{@const fullRoute =
			(params.wildcats ? '/wildcats' : '') +
			`/saison/${params.seasonId}/teams/${params.teamId}/${route}`}
		{@const matches = exact
			? page.url.pathname === fullRoute || page.url.pathname + '/' === fullRoute
			: page.url.pathname.startsWith(fullRoute)}
		<a
			href={`${fullRoute}#teamContent`}
			class={twMerge(
				'bg-base-100 shadow-accent/10 grid place-content-center py-1 text-lg font-bold tracking-wider uppercase hover:shadow-xl',
				matches ? 'border-accent border-b-2' : ''
			)}
		>
			{label}
		</a>
	{/snippet}

	<div class="grid grid-cols-1 gap-1 sm:grid-cols-3">
		{@render menuItem('', 'Statistiken', true)}
		{@render menuItem('spieler', 'Spieler', true)}
		{@render menuItem('spiele', 'Spiele', true)}
	</div>

	{@render children()}
</div>
